import Axios, { AxiosRequestConfig } from 'axios'
import store from '@/store'

/**
 * 셀러 직접발급 쿠폰 — adminapi(FastAPI) 호출 헬퍼.
 *
 * CoordiAdminApi 와 동일 패턴(raw Axios + 호출부 헤더 명시). 응답 형태 { meta: { code, message }, data }.
 * 모든 요청에 sellerNo 를 자동 첨부한다 — 셀러 계정은 서버가 무시하고 본인으로 고정하며,
 * 관리자 대리 로그인(마스터 계정)에서는 이 값이 스코프 셀러가 된다 (상세 GET·수정/종료 PUT 포함).
 */

export const SELLER_COUPON_BASE = '/v1/seller-coupons'

const baseUrl = () => process.env.VUE_APP_SERVER_ENDPOINT_ADMINAPI

const authHeaders = () => ({
  Authorization: store.getters.token || localStorage.getItem('accessToken'),
  'Service-No': store.getters.serviceNo,
})

const config = (extra?: AxiosRequestConfig): AxiosRequestConfig => ({
  ...extra,
  params: { sellerNo: store.getters.sellerNo, ...((extra?.params || {}) as Record<string, any>) },
  headers: { ...authHeaders(), ...((extra?.headers || {}) as Record<string, string>) },
})

export const sellerCouponApi = {
  get(path: string, params?: Record<string, any>, extra?: AxiosRequestConfig) {
    return Axios.get(`${baseUrl()}${path}`, config({ ...extra, params }))
  },
  post(path: string, body?: any) {
    return Axios.post(`${baseUrl()}${path}`, body, config())
  },
  put(path: string, body?: any) {
    return Axios.put(`${baseUrl()}${path}`, body, config())
  },
}

/** adminapi 에러 응답에서 사용자 메시지 추출 (없으면 fallback). */
export const sellerCouponApiError = (error: any, fallback: string): string => {
  return error?.response?.data?.meta?.message || fallback
}
